module.exports = __webpack_public_path__ + "static/media/No-Appointment-Calendar.7f323303.jpg";